import React from 'react'
import './CopyRight.css'

const CopyRight = () => {
  return (
    <div className="Copyright">
        <p><span>© </span> Copyright Lesson Link</p>
    </div>
  )
}

export default CopyRight;